export default __webpack_public_path__ + "locales/pl/ResetApplicationDialog.json?hash=e5157691c0a87cdfdca407b17616b092";